import * as Yup from 'yup'

const RecoverPasswordValidationSchema = Yup.object().shape({
    email: Yup.string()
        .email('Ingresa un email válido')
        .required('El email es requerido'),
})

export default RecoverPasswordValidationSchema
